import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class OrdersRepositoryService {
    constructor(http) {
        this.http = http;
    }
    listByAccountId(accountId) {
        return this.http.get(`${environment.apiUrl}v1/accounts/${accountId}/orders`);
    }
    findByAccountIdAndOrderNo(accountId, orderNo) {
        const orderNoNorm = orderNo.replace('/', '-');
        return this.http.get(`${environment.apiUrl}v1/accounts/${accountId}/orders/${orderNoNorm}`);
    }
}
OrdersRepositoryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function OrdersRepositoryService_Factory() { return new OrdersRepositoryService(i0.ɵɵinject(i1.HttpClient)); }, token: OrdersRepositoryService, providedIn: "root" });
